import { env } from '@/config/env';

const FALLBACK_SDK_URL = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';

export function initCookieConsent(): void {
  if (document.querySelector('script[data-domain-script]')) return;

  const domainScript = env.VITE_ONETRUST_DOMAIN_SCRIPT;
  if (!domainScript) return;

  const globalWindow = window as Window & { OptanonWrapper?: () => void };

  if (typeof globalWindow.OptanonWrapper !== 'function') {
    globalWindow.OptanonWrapper = () => {};
  }

  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.charset = 'UTF-8';
  script.src = env.VITE_ONETRUST_SDK_URL ?? FALLBACK_SDK_URL;
  script.setAttribute('data-domain-script', domainScript);
  document.head.appendChild(script);
}
